import { Vue, Component } from 'vue-property-decorator';
import { myGooruAPI } from '@/providers/apis/my-gooru/my-gooru';
import { tenantSettingsAPI } from '@/providers/apis/tenant-settings/tenant-settings';
import { sessionService } from '@/providers/services/auth/session';
import { DEFAULT_IMAGES_PATH } from '@/utils/constants';
import CreateNewPopUpComponent from '@/components/my-gooru-pages/create-new-nudge/create-new-nudge';
import ClassesPage from '@/components/rosters-pages/classes/classes';
import { NewNudge } from '@/models/nudge-config/newNudge';
import { ref } from 'vue';

@Component({
  name: 'nudge-config-page',
  components: {
    CreateNewPopUpComponent,
  },
})
export default class NudgeConfigPageComponent extends Vue {
  private nudgesList: any = ref([]);
  private searchAccessList: string = '';
  private offset: number = 0;
  private limit: number = 100;
  private isLoading: boolean = false;
  private tenantListTotalCount: any = '';
  private searchTeantList = '';
  private tenantListData: any = [];
  private errorMsg = false;
  private searchLoader = false;
  private countCheck = 0;
  private tenantSelectItem = '';
  private tenantId = '';
  private selectedTenant: any = undefined;
  private updatingNudge: any;
  private isEdit: boolean = false;
  private isNudgeListLoading = false;
  private noDataAvailable = false;
  private noNudgesAvailable = false;

  private defaultTenant: any;
  private session: any;

  private debouncedSearchAccess = this.debounce(
    this.searchAccess.bind(this),
    300,
  );
  private debouncedTenantSearchAccess = this.debounce(
    this.searchTeant.bind(this),
    300,
  );

  private setDefaultImage(index: any) {
    this.nudgesList[index].thumbnail.thumbnailUrl =
      this.nudgesList[index].nudge_id === 'recharge'
        ? '/img/default-images/recharge.svg'
        : '/img/default-images/profile.png';
  }
  private created() {
    this.session = sessionService.getSession();
    this.getTenantList();
    this.getTenantDetails();
  }

  private async getTenantDetails() {
    this.isNudgeListLoading = true;
    const tenantId: any = this.session!.tenant!.tenant_id;
    tenantSettingsAPI.fetchTenantById(tenantId).then((tenantDetail) => {
      this.defaultTenant = tenantDetail;
      this.getTenantNudges(this.defaultTenant);
      this.isNudgeListLoading = false;
    });
  }

  private async getTenantNudges(tenantSelectItem: any) {
    this.isLoading = true;
    (this.$refs.dropdown as any).hide();

    this.tenantId = tenantSelectItem.id;
    await tenantSettingsAPI
      .fetchNudgesDetail(this.tenantId)
      .then((nudgesRes) => {
        if (nudgesRes.list.length === 0) {
          this.noNudgesAvailable = true;
          this.nudgesList = nudgesRes.list;
          this.isLoading = false;
          this.selectedTenant = tenantSelectItem;
          this.defaultTenant = tenantSelectItem;
          this.tenantSelectItem = tenantSelectItem.name;
          this.searchLoader = false;
        } else {
          this.noNudgesAvailable = false;
          const cdnUrls = sessionService.getCdnUrl();
          const contentCdnUrl = cdnUrls.content_cdn_url;
          nudgesRes.list.map((lists: any) => {
          lists.thumbnail.thumbnailUrl = lists.thumbnail.icon
            ? contentCdnUrl + lists.thumbnail.icon
            : `${window.location.origin}` + DEFAULT_IMAGES_PATH.assessment;
        });
          this.nudgesList = nudgesRes.list;
          this.isLoading = false;
          this.selectedTenant = tenantSelectItem;
          this.defaultTenant = tenantSelectItem;
          this.tenantSelectItem = tenantSelectItem.name;
          this.searchLoader = false;
      }
      });
  }

  private clearSelectedTenant() {
    this.selectedTenant = this.defaultTenant;
    this.tenantSelectItem = '';
    this.isLoading = false;
    this.searchLoader = false;
  }

  private searchTeant() {
    if (this.searchTeantList.length > 3) {
      this.errorMsg = false;
      this.offset = 0;
      this.limit = 100;
      this.getTenantList();
    } else {
      this.getTenantList();
    }
  }
  private searchTenantListClear() {
    this.searchTeantList = '';
    this.offset = 0;
    this.limit = 100;
    this.getTenantList();
  }
  private async getTenantList() {
    this.searchLoader = true;
    const offset = this.offset;
    const limit = this.limit;
    const name = this.searchTeantList;
    const params: any = {
      offset,
      limit,
      name,
    };

    await myGooruAPI.getTenantList(params).then((response: any) => {
      this.countCheck++;
      this.searchLoader = false;
      this.isLoading = false;
      if (this.searchTeantList.length > 3) {
        this.tenantListData = [];
      }
      this.tenantListTotalCount = response.data.total_count;
      this.tenantListData.push(response.data.list);
      if (this.tenantListData[0].length === 0) {
        this.noDataAvailable = true;
      } else {
        this.noDataAvailable = false;
      }
    });
  }

  private handleScroll(event: Event) {
    this.isLoading = false;
    const target = event.target as HTMLElement;
    const roundOffValue = Math.trunc(target.scrollHeight - target.scrollTop);
    const scrollBottom = roundOffValue === target.clientHeight;
    const pageLimitCount = this.tenantListTotalCount / this.limit;
    if (scrollBottom && this.countCheck < pageLimitCount) {
      this.offset = this.offset + 100;
      this.isLoading = true;
      this.getTenantList();
    }
  }

  private selectTenantItem(tenantSelectItem: any) {
    this.isLoading = true;
    (this.$refs.dropdown as any).hide();

    this.tenantId = tenantSelectItem.id;
    tenantSettingsAPI.fetchNudgesDetail(this.tenantId).then((nudgesRes) => {
      const cdnUrls = sessionService.getCdnUrl();
      const contentCdnUrl = cdnUrls.content_cdn_url;
      nudgesRes.list.map((lists: any) => {
        lists.thumbnail.thumbnailUrl = lists.thumbnail.icon
          ? contentCdnUrl + lists.thumbnail.icon
          : `${window.location.origin}` + DEFAULT_IMAGES_PATH.assessment;
      });
      this.nudgesList = nudgesRes.list;
      this.isLoading = false;
      this.tenantSelectItem = tenantSelectItem.name;
      this.selectedTenant = tenantSelectItem;
    });
  }

  private searchAccess() {
    const trimmedSearch = this.searchAccessList.trim();

    if (trimmedSearch && trimmedSearch.length >= 3) {
      this.errorMsg = false;
      this.offset = 0;
      this.limit = 100;
      this.searchLoader = true;
      this.filterNudges(trimmedSearch);
    } else {
      this.getTenantNudges(this.selectedTenant);
    }
  }

  private searchAccessListClear() {
    this.searchAccessList = '';
    this.getTenantNudges(this.selectedTenant);
    this.isLoading = false;
    this.searchLoader = false;
  }

  private filterNudges(searchText: string) {
    const lowerCaseSearch = searchText.toLowerCase();
    this.nudgesList = this.nudgesList.filter(
      (nudge: any) =>
        nudge.title.toLowerCase().includes(lowerCaseSearch) ||
        nudge.nudge_id.toLowerCase().includes(lowerCaseSearch),
    );
    this.searchLoader = false;
  }

  private async updateNudgeModal(pageType: any, nudgeId: any) {
    const foundNudge = await this.nudgesList.find(
      (nudge: any) => nudge.page_type === pageType && nudge.nudge_id === nudgeId,
    );
    if (foundNudge) {
      this.updatingNudge = { ...foundNudge };
      this.updatingNudge.tenant_id = this.selectedTenant.id;
      this.updatingNudge.action = foundNudge.action
        ? foundNudge.action.replace(/['"{}]/g, '').split(',')
        : null;
      this.isEdit = true;
      this.$bvModal.show('create-new-nudge');
    }
  }

  private createNudgeModal() {
    this.isEdit = false;
    this.updatingNudge = '';

    this.$bvModal.show('create-new-nudge');
  }

  private clearUpdatingNudge() {
    this.updatingNudge = undefined;
    this.isEdit = false;
  }

  private debounce(func: (...args: any[]) => void, delay: number) {
    let timer: any;
    return function(this: NudgeConfigPageComponent, ...args: any[]) {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }

  private async onAccessChange(id: any) {
    const nudge = this.nudgesList.find(
      (item: any) => item.nudge_mapping_id === id,
    );

    if (nudge) {
      const access = nudge.is_access;
      const nudgeId = nudge.nudge_id;
      const nudgeMappingId = parseInt(nudge.nudge_mapping_id, 10);

      if (!access) {
        const response = await myGooruAPI.updateNudgeMapping(nudgeMappingId, {
          is_access: false,
        });
        this.getTenantNudges(this.selectedTenant);
      } else {
        const response = await myGooruAPI.updateNudgeMapping(nudgeMappingId, {
          is_access: true,
        });
        this.getTenantNudges(this.selectedTenant);
      }
    } else {
      return;
    }
  }

  private isUpdatedToday(dateString: string | Date): boolean {
    const updatedDate = new Date(dateString);
    const today = new Date();

    return (
      updatedDate.getFullYear() === today.getFullYear() &&
      updatedDate.getMonth() === today.getMonth() &&
      updatedDate.getDate() === today.getDate()
    );
  }
}
